import { useRoute } from 'vue-router';
import { computed } from 'vue';

export function useRouteAdviseurnummer() {
  const route = useRoute();

  const adviseurnummer = computed(() => Number(route.params.adviseurnummer));

  return {
    adviseurnummer,
  };
}
